import ExcelJS from 'exceljs'
import encoding from 'encoding-japanese'
import moment from 'moment-timezone'
/**
 * CSV出力
 * @param filename ファイル名
 * @param headers ヘッダーラベル
 * @param data データセット
 */
export const ExportCsvHelper = async (filename: string, headers: any[], data: any[]) => {
  // Workbookの作成
  const workbook = new ExcelJS.Workbook()
  // Workbookに新しいWorksheetを追加
  workbook.addWorksheet('sheet1')
  // 追加したWorksheetを参照し変数に代入
  const worksheet = workbook.getWorksheet('sheet1')
  // 列を定義
  worksheet.columns = headers
  // 行を定義
  for (const row of data) {
    worksheet.addRow(row)
  }
  // UInt8Arrayを生成
  const uint8Array = new Uint8Array(
    encoding.convert(
      await workbook.csv.writeBuffer({
        formatterOptions: { quote: true, quoteColumns: true, quoteHeaders: true }
      }),
      {
        from: 'UTF8',
        to: 'SJIS'
      }
    )
  )
  // Blobを生成
  const blob = new Blob([uint8Array], { type: 'application/octet-binary' })
  // DL用URLを生成し、aタグからダウンロードを実行
  const url = window.URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = `${filename}-${moment().format('YYYYMMDD-HHmm')}.csv`
  a.click()
  a.remove()
  return
}
